import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/Button";
import { cn } from "@/utils/helpers";
import { HTMLAttributes, ReactNode } from "react";
export interface TabItem {
  id: string;
  label: string;
  icon?: ReactNode;
}
export interface TabsProps extends HTMLAttributes<HTMLDivElement> {
  items: TabItem[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
}
export const Tabs = t0 => {
  const $ = _c(19);
  let activeTab;
  let className;
  let items;
  let onTabChange;
  let props;
  if ($[0] !== t0) {
    ({
      items,
      activeTab,
      onTabChange,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = activeTab;
    $[2] = className;
    $[3] = items;
    $[4] = onTabChange;
    $[5] = props;
  } else {
    activeTab = $[1];
    className = $[2];
    items = $[3];
    onTabChange = $[4];
    props = $[5];
  }
  let t1;
  if ($[6] !== className) {
    t1 = cn("flex flex-wrap justify-center lg:justify-start gap-3 mb-6 w-full", className);
    $[6] = className;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== activeTab || $[9] !== items || $[10] !== onTabChange) {
    let t3;
    if ($[12] !== activeTab || $[13] !== onTabChange) {
      t3 = item => {
        const isActive = activeTab === item.id;
        return <Button key={item.id} onClick={() => onTabChange(item.id)} variant="primary" icon={item.icon} className={cn("flex-1", !isActive && "opacity-50")} aria-label={`Switch to ${item.label}`}>{item.label}</Button>;
      };
      $[12] = activeTab;
      $[13] = onTabChange;
      $[14] = t3;
    } else {
      t3 = $[14];
    }
    t2 = items.map(t3);
    $[8] = activeTab;
    $[9] = items;
    $[10] = onTabChange;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[15] !== props || $[16] !== t1 || $[17] !== t2) {
    t3 = <div className={t1} {...props}>{t2}</div>;
    $[15] = props;
    $[16] = t1;
    $[17] = t2;
    $[18] = t3;
  } else {
    t3 = $[18];
  }
  return t3;
};